var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCreditCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.121 11.25H15.2033C14.1695 11.25 13.3281 12.1436 13.3281 13.2418V21.2088C13.3281 22.3069 14.1695 23.2005 15.2033 23.2005H28.121C29.1549 23.2005 29.9963 22.3069 29.9963 21.2088V13.2418C29.9963 12.1436 29.1549 11.25 28.121 11.25ZM17.7036 15.2335H16.4535C16.1084 15.2335 15.8284 14.9361 15.8284 14.5696C15.8284 14.2031 16.1084 13.9057 16.4535 13.9057H17.7036C18.0487 13.9057 18.3287 14.2031 18.3287 14.5696C18.3287 14.9361 18.0487 15.2335 17.7036 15.2335ZM21.6616 19.8809C20.2827 19.8809 19.1613 18.6899 19.1613 17.2253C19.1613 15.7607 20.2827 14.5696 21.6616 14.5696C23.0405 14.5696 24.1619 15.7607 24.1619 17.2253C24.1619 18.6899 23.0405 19.8809 21.6616 19.8809ZM26.8709 20.5448H25.6208C25.2757 20.5448 24.9957 20.2474 24.9957 19.8809C24.9957 19.5144 25.2757 19.217 25.6208 19.217H26.8709C27.2159 19.217 27.496 19.5144 27.496 19.8809C27.496 20.2474 27.2159 20.5448 26.8709 20.5448Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8756 24.5237H13.9579C12.924 24.5237 12.0827 23.6301 12.0827 22.532V14.7734L10.0612 22.7803C9.80116 23.8346 10.3937 24.9287 11.3876 25.2195L24.2753 28.8857C24.4353 28.9308 24.5953 28.9507 24.7529 28.9507C25.5829 28.9507 26.343 28.3625 26.5618 27.4768L27.3294 24.4587C27.1831 24.4972 27.0331 24.5237 26.8756 24.5237Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_credit_card.8b36ee229d8f5fa1d5bb4d2180e30be8.svg";